import { takeLeading, put } from "redux-saga/effects";
import * as keys from "constants/keys";
import { setAccessToken, setLoadTokenStatus } from "actions/user";

function* execute() {
    yield put(setLoadTokenStatus("loading"));
    const token = localStorage.getItem(keys.AccessTokenKey);
    if (token) {
        yield put(setAccessToken(token));
    } else {
        localStorage.removeItem(keys.AccessTokenKey);
    }
    yield put(setLoadTokenStatus("none"));
}

export default function* saga(): Generator {
    yield takeLeading("com.sage.action.user.ILoadTokenFromStorage", execute);
}
